import { render } from "./IconClosedCaption.vue?vue&type=template&id=e126c18a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconClosedCaption.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e126c18a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e126c18a', __exports__)) {
    api.reload('e126c18a', __exports__)
  }
  
  module.hot.accept("./IconClosedCaption.vue?vue&type=template&id=e126c18a", () => {
    api.rerender('e126c18a', render)
  })

}


export default __exports__